<!--
칼럼 값 하나를 표현
-->
<template>
    <div :class="rootClass">
        <div :class="headerClass" :style="headerStyle">
            <!-- uikit 아이콘 -->
            <span v-if="icon === 'uk'" :uk-icon="'icon: ' + ukIcon + '; ratio: '+ukIconRatio" class="uk-text-middle"></span>

            <!-- 머테리얼 아이콘 -->
            <i v-if="icon === 'material'" class="material-icons">{{ materialIcon }}</i>

            <!-- 헤더 -->
            <span class="uk-text-middle">
                {{ header }}
            </span>

            <!-- 헤더 밑 버튼영역 -->
            <slot name="header-button"></slot>
        </div>
        <!-- 칼럼 값 -->
        <div :class="bodyClass">
            <slot></slot>
        </div>
        
    </div>

</template>

<script>

    // vue component
    export default {
        props: {
            /**
             * 칼럼헤더
             */
            header: {
                type: String,
                default: null,
            },
            /**
             * 헤더 사이즈
             */
            headerSize: {
                type: String,
                default: 'small',
            },
            /**
             * 바디 사이즈
             */
            bodySize: {
                type: String,
                default: 'large',
            },
            /**
            /**
             * 헤더 색상
             */
            headerColor: {
                type: String,
                default: 'blur',
            },
            /**
             * 바디 색상
             */
            bodyColor: {
                type: String,
                default: 'default',
            },
            /**
             * 헤더 정렬
             */
            headerAlign: {
                type: String,
                default: 'center',
            },
            /**
             * 바디 정렬
             */
            bodyAlign: {
                type: String,
                default: 'center',
            },
            /**
             * uikit 아이콘 이름
             */
            ukIcon: {
                type: String,
                default: 'info',
            },
            /**
             * 머테리얼 아이콘 이름
             */
            materialIcon: {
                type: String,
                default: null,
            },
            /**
             * 강조
             */
            highlight: {
                type: Boolean,
                default: false,
            },
            /**
             * 수평으로 display
             */
            horizontal: {
                type: Boolean,
                default: false,
            },
            /**
             * 헤더 width
             * ex ) '200px'
             */
            headerWidth: {
                type: String,
                default: null,
            },
            /**
             * 바디 width
             * ex ) 'expand', 'auto'
             */
            bodyWidth: {
                type: String,
                default: 'expand',
            },
        },
        data: function () {
            return {
                // 헤더 style
                headerStyle: {
                    width: this.headerWidth ? this.headerWidth : 'auto',
                },
            };
        },
        computed: {
            /**
             * 아이콘 종류
             */
            icon: function () {
                if (this.materialIcon !== null) {
                    return 'material';
                } else {
                    return 'uk';
                }
            },
            /**
             * 루트 클래스
             */
            rootClass: function () {
                let class_name = 'root';

                // 하이라이트
                if (this.highlight) {
                    class_name += ' highlight';
                }

                // horizontal
                if (this.horizontal) {
                    class_name += ' horizontal';
                }

                return class_name;
            },
            /**
             * 헤더 클래스
             */
            headerClass: function () {
                let class_name = 'header text-break';

                // 색상
                class_name += ' color-' + this.headerColor;

                // 사이즈
                class_name += ' ' + this.headerSize;

                // 정렬
                class_name += ' ' + this.headerAlign;

                return class_name;
            },
            /**
             * 헤더 uk-icon 크기
             */
            ukIconRatio: function () {
                if (this.headerSize === 'small') {
                    return 0.625;
                } else if (this.headerSize === 'medium') {
                    return 0.75;
                } else if (this.headerSize === 'large') {
                    return 1;
                }
                
            },
            /**
             * 바디 클래스
             */
            bodyClass: function () {
                return {
                    body: true,
                    'text-break': true,

                    // 색상
                    'color-blur': this.bodyColor === 'blur',
                    'color-default': this.bodyColor === 'default',
                    'color-primary': this.bodyColor === 'primary',
                    'color-black': this.bodyColor === 'black',

                    // 사이즈
                    small: this.bodySize === 'small',
                    medium: this.bodySize === 'medium',
                    large: this.bodySize === 'large',

                    // 정렬
                    left: this.bodyAlign === 'left',
                    center: this.bodyAlign === 'center',
                    right: this.bodyAlign === 'right',

                    // width
                    'uk-width-1-1': this.horizontal === false,
                    'uk-width-expand': this.horizontal && this.bodyWidth === 'expand',
                    'uk-width-auto': this.horizontal && this.bodyWidth === 'auto',
                };
            },
        },
        watch: {
        },
        methods: {

        }
    }
</script>

<style lang="scss" scoped>
/*
    .header {
    }
    */
    .body {
        margin-top: 10px;
    }

    // 색상
    .color-blur {
        color: #999;
    }
    .color-default {
        color: #666;
    }
    .color-primary {
        color: #1e87f0;
    }
    .color-black {
        color: #000;
    }

    

    // text-break
    .text-break {
        overflow-wrap: break-word;
        word-wrap: break-word;
        -ms-hyphens: auto;
        -webkit-hyphens: auto;
        hyphens: auto;
    }        

    // 사이즈
    .small {
        font-size: 0.875rem;

        .material-icons {
            font-size: 1rem;
        }
    }
    .medium {
        font-size: 1rem;

        .material-icons {
            font-size: 1.25rem;
        }
    }
    .large {
        font-size: 1.25rem;

        .material-icons {
            font-size: 1.5rem;
        }
    }

    // 정렬
    .left {
        text-align: left;
    }
    .center {
        text-align: center;
    }
    .right {
        text-align: right;
    }

    // 하이라이트
    .highlight {
        .header {
            color: #666 !important;
        }
        .body {
            color: #1e87f0 !important;
        }
    }

    // horizontal (uk-grid 에서 css 베껴옴)
    .horizontal {
        display: -ms-flexbox;
        display: flex;
        /* 1 */
        -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;

        align-content: flex-start;
        align-items: center;
        justify-content: flex-start;

        /* 2 */
        margin: 0;
        padding: 0;
        list-style: none;

        .header {
            margin: 0;
            padding-right: 10px;
        }
        .body {
            margin: 0;
        }
    }
</style>